import React, { Component, CSSProperties } from 'react';
import path from 'path-browserify';

import { TreeLayer } from './tree-layer';
import { TreeNodeProps, TreeNode } from './tree-types';

export function defaultNodeComponentProvider<T>(node: TreeNode<T>) {
	if (node.children) {
		return InnerNodeView;
	}

	return LeafView;
}

export function LeafView<T>({ node, depth, getTreeNodeComponent }: TreeNodeProps<T>) {
	const { id } = node;

	const name = path.basename(id);

	return <div>{name}</div>;
}

export class InnerNodeView<T> extends Component<TreeNodeProps<T>> {
	state = { isOpen: false };
	render() {
		const { node, depth, getTreeNodeComponent } = this.props;
		const { isOpen } = this.state;

		const { id } = node;
		const name = path.basename(id);

		const childrenStyle: CSSProperties = { paddingLeft: '8px' };
		const containerStyle: CSSProperties = {};
		// if (isDropHover) {
		// 	containerStyle.border = '1px solid grey';
		// 	containerStyle.background = 'lightgray';
		// }

		return (
			<div style={containerStyle}>
				<div onClick={() => this.setState({ isOpen: !isOpen })}>
					<span style={{ userSelect: 'none' }}>{isOpen ? '-' : '+'}</span>
					{name}
				</div>
				{isOpen && node.children && (
					<div style={childrenStyle}>
						<TreeLayer
							childNodes={node.children}
							depth={depth}
							getTreeNodeComponent={getTreeNodeComponent}
						/>
					</div>
				)}
			</div>
		);
	}
}
